module.exports = __webpack_public_path__ + "54de07a08db82bb4259c8831baa0c16a.fbx";